export default function ActionContainer(props){
    return (
        // <td className="px-2 first:pl-2 last:pr-3 py-3 whitespace-nowrap pointer">
            <div className="flex items-left gap-2">
                {props.children}
            </div>
        // </td>
    )
  }
  